module.exports = __webpack_public_path__ + "img/tablaCoronavirus.a17a56b5.jpg";